import React from 'react';
import logo from '../assets/img/logo.jpeg';
import { Link } from "react-router-dom";
interface HeaderProps {
    className?: string;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
    return (
        <div className={`container-center ${props?.className}`}>
            <Link to="/">
                <img className="col-4" src={logo} style={{ width: '200px', margin: '0 auto' }} alt="Logo" />
            </Link>
        </div>
    );
}

export default Header;